import { render, staticRenderFns } from "./stockquantity.vue?vue&type=template&id=5f74a8ba&"
import script from "./stockquantity.vue?vue&type=script&lang=js&"
export * from "./stockquantity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/domains/b2b/htdocs/local/templates/b2bmodern_default/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f74a8ba')) {
      api.createRecord('5f74a8ba', component.options)
    } else {
      api.reload('5f74a8ba', component.options)
    }
    module.hot.accept("./stockquantity.vue?vue&type=template&id=5f74a8ba&", function () {
      api.rerender('5f74a8ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/scripts/vue/components/catalog/stockquantity.vue"
export default component.exports